module.exports = __webpack_public_path__ + "static/che16-802320a1cdf084e0a07aa0d67f7944ed.jpg";